// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videotest {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.videotest > *:last-child {
  margin-top: auto;
}
.videotest__stage {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.videotest__player {
  min-width: 0;
  flex: 1;
}
.videotest__diagnostics {
  min-width: 0;
}
@media (min-width: 992px) {
  .videotest__stage--with-diagnostics {
    flex-direction: row;
    align-items: flex-start;
    padding: 0 16px;
  }
  .videotest__stage--with-diagnostics .videotest__diagnostics {
    flex: 0 0 380px;
    width: 380px;
    position: sticky;
    top: 16px;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Videotest/Videotest.scss"],"names":[],"mappings":"AAEA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AADJ;AAGI;EACI,gBAAA;AADR;AAMI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAJR;AAOI;EACI,YAAA;EACA,OAAA;AALR;AAQI;EACI,YAAA;AANR;AASI;EACI;IACI,mBAAA;IACA,uBAAA;IACA,eAAA;EAPV;EAUM;IACI,eAAA;IACA,YAAA;IACA,gBAAA;IACA,SAAA;IACA,8BAAA;IACA,gBAAA;EARV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
